import React, { FC, useEffect, useState } from 'react';
import History from 'src/components/History';
import { ConstantsCodesObjectType } from 'src/types/constantsCodes';
import { ReturnChangelogType } from 'src/types/returnDetail';
import { historyProductUpdates, historyReturnFilesUpdates, historyUpdates, historyUpdatesSkladonUser, historyCreateHiddenKeys } from './constants';
import CheckIcon from '@mui/icons-material/Check';
import { ProductListType } from 'src/types/product';

export interface HistoryPropsType {
    changelog: ReturnChangelogType | null;
    returnStatusCodesObject: ConstantsCodesObjectType;
    retunReasonCodesObject: ConstantsCodesObjectType;
    lineStateCodesObject: ConstantsCodesObjectType;
    returnResolutionCodesObject: ConstantsCodesObjectType;
    boolNumberCodesObject: ConstantsCodesObjectType;
    transportPaidByCodesObject: ConstantsCodesObjectType;
    sourceSysCodesObject: ConstantsCodesObjectType;
    orderTypeCodesObject: ConstantsCodesObjectType;
    productsData: Pick<ProductListType, 'ID' | 'SKU'>[] | null;
    skladonUser?: number;
}

const HistoryBlock: FC<HistoryPropsType> = (props) => {
    const [formated, setFormated] = useState<ReturnChangelogType | null>(null);

    useEffect(() => {
        if (props.changelog && props.productsData) {
            setFormated({
                ...props.changelog,
                updates: props.changelog.updates.map((update) => {
                    const newData = update.data && { ...update.data };
                    if (newData?.RETURNED_ORDER_PRODUCTS) {
                        // @ts-ignore
                        newData.RETURNED_ORDER_PRODUCTS = newData.RETURNED_ORDER_PRODUCTS.map((returnProduct) => {
                            if (!returnProduct?.SKU && returnProduct?.PRODUCT_ID) {
                                const product = props.productsData?.find(
                                    (product) => product.ID === returnProduct.PRODUCT_ID
                                );
                                if (product) {
                                    return { ...returnProduct, SKU: product.SKU };
                                }
                            }
                            return returnProduct;
                        });
                    }
                    if (newData?.FILES) {
                        // @ts-ignore
                        newData.FILES = newData.FILES.map((file) => {
                            if (!file || typeof file !== 'object') {
                                return file;
                            }
                            return {
                                ...file,
                                fileName: file.fileName ?? file.ORIGINAL_FILE_NAME,
                                type: file.type ?? file.TYPE,
                            };
                        });
                    }
                    return { ...update, data: newData };
                }),
            });
        }
    }, [props.changelog, props.productsData]);

    return (
        <History
            updates={formated?.updates}
            updateKeys={props.skladonUser ? historyUpdatesSkladonUser : historyUpdates}
            updateItemsKeys={{
                // RETURNED_ORDER_PRODUCTS: { requiredItems: ['PRODUCT_ID'], itemKeys: historyProductUpdates },
                RETURNED_ORDER_PRODUCTS: { requiredItems: ['SKU'], itemKeys: historyProductUpdates },
                FILES: { requiredItems: ['fileName'], itemKeys: historyReturnFilesUpdates },
            }}
            keyCodes={{
                STATUS: props.returnStatusCodesObject,
                TRANSPORT_PAID_BY: props.transportPaidByCodesObject,
                SOURCE_SYS: props.sourceSysCodesObject,
                ORDER_TYPE: props.orderTypeCodesObject,
            }}
            keyItemsCodes={{
                RETURNED_ORDER_PRODUCTS: {
                    LINE_STATE: props.lineStateCodesObject,
                    RETURN_REASON: props.retunReasonCodesObject,
                    RESOLUTION: props.returnResolutionCodesObject,
                },
            }}
            translatePrefix="returnDetail"
            createHiddenKeys={historyCreateHiddenKeys}
            customIconFce={(row) => {
                if (row.message === 'confirmReturn') {
                    return <CheckIcon fontSize="small" />;
                }
                return null;
            }}
        />
    );
};

export default HistoryBlock;
